import { AxiosResponse } from 'axios';
import { call, select } from 'redux-saga/effects';

import { getCastCrewPrograms } from 'config/api';

import {
    CastCrewResponse,
    RBProgram,
    ResponseError,
} from 'store/railsBuilder/reducer.types';
import { RecordingItem } from 'store/recordings/reducer.types';
import { AuthData } from 'store/user/reducer.types';
import { selectUserAuthData } from 'store/user/selectors';

import { VodEditorial } from 'services/data-manager/types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';
import { isRecordingItem } from 'utils/recordings';

export default function* loadCastAndCrewData(
    asset: RBProgram | VodEditorial | RecordingItem,
) {
    try {
        const authData: AuthData | undefined = yield select(selectUserAuthData);

        if (authData) {
            let playlistId = asset.id;

            if (isRecordingItem(asset)) {
                playlistId = (asset as RecordingItem).contentId;
            } else if ((asset as RBProgram).contentRef) {
                playlistId = (asset as RBProgram).contentRef;
            }

            const castCrewProgramsResponse: AxiosResponse<
                CastCrewResponse | ResponseError
            > = yield call(
                NagraInstance.get,
                getCastCrewPrograms(playlistId!, authData.access_token),
            );

            const {
                data: { castCrewPersonas },
            } = castCrewProgramsResponse as AxiosResponse<CastCrewResponse>;

            const {
                data: { error: castCrewProgramsError },
            } = castCrewProgramsResponse as AxiosResponse<ResponseError>;

            if (!castCrewProgramsError && castCrewPersonas.length) {
                return castCrewPersonas;
            }
        }

        return [];
    } catch (error) {
        if (__DEV__) {
            console.warn('Cast&Crew loading error: ', error);
        }

        return [];
    }
}
